import { resolveComponent as t, openBlock as o, createElementBlock as e, Fragment as m, renderList as c, createVNode as n, withCtx as _ } from "vue";
import { _ as a } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import p from "../skeleton/skeleton.js";
import l from "../list-item/list-item.js";
const d = {
  name: "ComboboxLoadingList",
  components: { DtListItem: l, DtSkeleton: p }
}, f = {
  class: "d-combobox__loading-list",
  "aria-busy": "true"
};
function u(b, x, k, L, g, y) {
  const s = t("dt-skeleton"), r = t("dt-list-item");
  return o(), e("ol", f, [
    (o(), e(m, null, c(7, (i) => n(r, {
      key: i,
      role: "option",
      "navigation-type": "none"
    }, {
      default: _(() => [
        n(s, {
          "text-option": { type: "body" },
          offset: 0
        })
      ]),
      _: 1
    })), 64))
  ]);
}
const B = /* @__PURE__ */ a(d, [["render", u]]);
export {
  B as default
};
//# sourceMappingURL=combobox-loading-list.js.map
